import { createUpdateFlagsExtension } from '@spotify/plugin-confidence-workflows-react';

export const ROLLOUT_FLAG_CHANGE_EXTENSION = createUpdateFlagsExtension({
  id: 'rollout-flag-config-change',
  fieldPath: '/module_data/flags',
});
